// extracted by mini-css-extract-plugin
export default {"title":"lzqe6"};